"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _logger = require("@insided/shared/services/logger");

var _preactPortal = _interopRequireDefault(require("preact-portal"));

var _flowtipCore = _interopRequireDefault(require("flowtip-core"));

var _typeGuards = require("../../libs/typeGuards");

var _Popover = _interopRequireDefault(require("@insided/deprecated-preact-components/Popup/Popover"));

var _AnimateTransition = _interopRequireDefault(require("../../components/transition/AnimateTransition"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var showDelay = 70;
var hideDelay = 300;
var showIndex = 5225; // 5000 -> popup

var initialIndex = 5224;
var ANIMATION_STATES = {
  hidden: {
    keyframes: [{
      opacity: 0,
      transform: 'translateY(5%) scale(0.95)',
      pointerEvents: 'none'
    }]
  },
  visible: {
    keyframes: [{
      opacity: 0,
      transform: 'translateY(5%) scale(0.95)',
      pointerEvents: 'none'
    }, {
      opacity: 1,
      transform: 'translateY(0) scale(1)',
      pointerEvents: 'auto'
    }],
    duration: 150,
    easing: 'ease-out'
  }
};

var Popup = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Popup, _Component);

  var _super = _createSuper(Popup);

  function Popup() {
    var _this;

    (0, _classCallCheck2.default)(this, Popup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "hideTimeout", 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "showTimeout", 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "popoverRef", (0, _preact.createRef)());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      zIndex: initialIndex,
      show: false,
      top: 0,
      left: 0
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "show", function () {
      clearTimeout(_this.hideTimeout);
      if (_this.state.show) return;
      _this.showTimeout = window.setTimeout(function () {
        if (_this.state.show) return;
        if (_this.props.onToggle) _this.props.onToggle(true);

        _this.calculateMetrics(_this.props);
      }, showDelay);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "calculateMetrics", function (props) {
      var _props$region;

      var bodyRect = document.body.getBoundingClientRect();
      var bounds = {
        left: 0,
        top: 0,
        width: document.documentElement.clientWidth - 15,
        height: document.documentElement.clientHeight - 15
      };

      var targetRect = _this.props.hoverControl.getBoundingClientRect();

      var result = (0, _flowtipCore.default)({
        target: targetRect,
        content: props.size,
        bounds: bounds,
        offset: props.offset,
        disabled: {
          left: true,
          right: true
        },
        region: (_props$region = props.region) !== null && _props$region !== void 0 ? _props$region : 'bottom',
        align: props.align
      });

      _this.setState({
        show: true,
        left: Math.floor(result.rect.left - bodyRect.left),
        top: Math.floor(result.rect.top - bodyRect.top),
        zIndex: showIndex
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "hide", function () {
      var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : hideDelay;
      clearTimeout(_this.hideTimeout);
      clearTimeout(_this.showTimeout);

      _this.setState({
        zIndex: initialIndex
      });

      _this.hideTimeout = window.setTimeout(function () {
        if (_this.props.onToggle) _this.props.onToggle(false);

        _this.setState({
          show: false
        });
      }, delay);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggle", function (on) {
      if (!_this.props.triggerOnClick) {
        on ? _this.show() : _this.hide();
      }
    });
    return _this;
  }

  (0, _createClass2.default)(Popup, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.triggerOnClick) {
        this.props.hoverControl.addEventListener('click', function (e) {
          e.preventDefault();

          _this2.show();
        });
        document.addEventListener('click', function (e) {
          var _this2$props$popupCla;

          var popup = document.body.querySelector(".".concat((_this2$props$popupCla = _this2.props.popupClass) !== null && _this2$props$popupCla !== void 0 ? _this2$props$popupCla : 'popup-component'));
          if (!_this2.state.show) return;
          if (_this2.props.hideOnClickInside) return _this2.hide(0);
          if (!popup) return;
          if (!(0, _typeGuards.isHtmlElement)(e.target)) return;
          if (popup.contains(e.target)) return;

          _this2.hide(0);
        });
      } else {
        try {
          var _this$props$hoverCont, _this$props$hoverCont2;

          (_this$props$hoverCont = this.props.hoverControl) === null || _this$props$hoverCont === void 0 ? void 0 : _this$props$hoverCont.addEventListener('mouseover', function () {
            return _this2.show();
          });
          (_this$props$hoverCont2 = this.props.hoverControl) === null || _this$props$hoverCont2 === void 0 ? void 0 : _this$props$hoverCont2.addEventListener('mouseout', function () {
            return _this2.hide();
          });
        } catch (error) {
          _logger.logger.error(error, {
            component: 'Popup',
            action: 'componentDidMount'
          });
        }
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (!this.state.show) return;
      if (nextProps.size.width === this.props.size.width && nextProps.size.height === this.props.size.height) return;
      this.calculateMetrics(nextProps);
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var _this$state = this.state,
          show = _this$state.show,
          left = _this$state.left,
          top = _this$state.top,
          zIndex = _this$state.zIndex;
      return (0, _preact.h)(_preactPortal.default, {
        into: "body"
      }, (0, _preact.h)("span", null, (0, _preact.h)(_AnimateTransition.default, {
        enter: "visible",
        exit: "hidden",
        states: ANIMATION_STATES
      }, show && (0, _preact.h)(_Popover.default, {
        ref: this.popoverRef,
        toggle: this.toggle,
        zIndex: zIndex,
        left: left,
        top: top,
        size: this.props.size,
        hide: this.hide,
        hoverControl: this.props.hoverControl,
        className: "popup-component"
      }, children))));
    }
  }]);
  return Popup;
}(_preact.Component);

var _default = Popup;
exports.default = _default;